<template>
    <div class="container">
        <p class="contentBlack">①如何成为对方守护天使？</p>
        <p class="content">文字、语音、视频聊天，以及赠送礼物均可增加守护值，与对方的守护值达到了一定程度即可守护，互相成为彼此的守护天使，语音、视频通话免费。</p>

        <p class="contentBlack">②守护值为什么下降？</p>
        <p class="content">守护值下降的比例是系统根据您与对方的具体情况自动判定哦，可以通过与对方互动赠礼一定比例保持守护值。</p>

        <p class="contentBlack">③如何维持守护值？</p>
        <p class="content">每天需新增对方魅力等级同等的守护值，即如果对方魅力等级是10级，那么每天需增加10点守护值就可以了。
            当守护等级达到“无上守护”时，则双方守护值永不下降，将成为一段美丽佳话，流传在{{ name }}平台。</p>

        <p class="contentBlack">④如何取代守护天使？</p>
        <p class="content">现守护天使的守护值高于原守护天使的守护值，即会被取代守护天使的位置，展示现守护天使，同时被取代后系统会下发提醒通知。</p>

        <p class="contentBlack"></p>
        <p class="content"></p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            id: '',
            gender: '',
            token: '',
            edition: '',

            name: '',
        }
    },

    created() {
        document.title = 'VIP会员服务协议';
        this.checkURLParams();
    },

    methods: {
        checkURLParams() {
            const url = window.location.href;
            const z = url.split('?');
            let p = {};
            try {
                const k = z[1].split('&');
                k.forEach(item => {
                    const m = item.split('=');
                    p[m[0]] = m[1];
                })
                this.id = p.id;
                this.gender = p.gender;
                this.token = p.token;
                this.checkName(p.edition);
            } catch(e) {}
        },

        checkName(edition) {
            let str = '';
            switch(edition) {
                case 'miyou':
                    this.name = '蜜柚';
                    break;

                case 'liaoban':
                    this.name = '聊伴交友';
                    break;

                case 'xunta':
                    this.name = '寻Ta交友';
                    break;

                default:
                    this.name = '本应用';
                    break;
            }
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    background-color: #FFF;
}

.content {
    font-size: 12px;
    color: #666;
}
.contentBlack {
    font-size: 12px;
    color: #000;
    font-weight: 600;
}
</style>